export * from './atoms';
export * from './organisms';


import { UserNotificationDialogAtoms } from "./atoms";
import { UserNotificationDialogOrganisms } from "./organisms";

export const UserNotificationDialogComponents = [ ...UserNotificationDialogAtoms, ...UserNotificationDialogOrganisms];